import { Component } from '@angular/core';
import { LoadingService } from '../../../core/services/loading/loading.service';
import { AppMaterialModule } from '../../../app-material.module';


@Component({
    selector: 'loading-panel',
    templateUrl: './loading-panel.component.html',
    styleUrls: ['./loading-panel.component.scss'],
    imports: [
    AppMaterialModule
]
})
export class LoadingPanelComponent {
    color: string = 'primary';
    mode: string = 'indeterminate';
    value: number = 50;


    constructor(public loadingService: LoadingService) {
    }
}
